<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.journalentry') }} > {{ this.$route.query.jv_code }}
      </BaseTopBarContent>
      <BaseTopBarContent class="col-md-8 right">
        <div
          v-if="journalEntry"
          class="action"
        >
          <div
            v-if="showOptionButton"
            class="dropdown item">
            <button
              id="dropdownMenuButton"
              class="btn no-bg dropdown-toggle text-secondary shake"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false">
              <i class="fas fa-cog"/>
              <span class="name">{{ $t('button.options') }}</span>
            </button>
            <div
              class="dropdown-menu dropdown-menu-right"
              aria-labelledby="dropdownMenuButton">
              <a
                v-if="this.hasRoleDelete"
                class="dropdown-item"
                @click="onOpenModal()"
              >
                <i class="fas fa-trash text-danger"/>
                <span class="text-danger">{{ $t('button.delete') }}</span>
              </a>
            </div>
          </div>
          <div
            v-if="hasRoleCreate"
            class="dropdown nodro item">
            <button
              class="btn no-bg text-secondary"
              type="button"
              @click="openCloneModal()">
              <i class="fas fa-copy"/>
              <span class="name">{{ $t('button.clone') }}</span>
            </button>
          </div>
          <!-- status button -->
          <div
            v-if="journalEntry.status == 'pending' && hasRoleApprove"
            class="dropdown item">
            <template>
              <button
                v-if="journalEntry.status == 'pending'"
                class="btn no-bg dropdown-toggle text-warning"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="far fa-circle"/>
                <span class="name">{{ $t('status.jv.pending') }}</span>
              </button>
              <button
                v-if="journalEntry.status == 'approved'"
                class="btn no-bg dropdown-toggle text-success"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="far fa-check-circle"/>
                <span class="name">{{ $t('status.jv.approved') }}</span>
              </button>
              <button
                v-if="journalEntry.status == 'rejected'"
                class="btn no-bg dropdown-toggle text-danger"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="far fa-times-circle"/>
                <span class="name">{{ $t('status.jv.rejected') }}</span>
              </button>
            </template>
            <div class="dropdown-menu dropdown-menu-right">
              <a
                v-if="journalEntry.status == 'pending'"
                class="dropdown-item"
                @click="updateStatus('approved')">
                <i
                  class="far fa-check-circle text-success"
                  style="position: relative; left: -7px;"/>
                <span class="text-success">{{ $t('status.jv.approve') }}</span>
              </a>
              <a
                v-if="journalEntry.status == 'pending'"
                class="dropdown-item"
                @click="updateStatus('rejected')">
                <i
                  class="far fa-times-circle text-danger"
                  style="position: relative; left: -7px;"/>
                <span class="text-danger">{{ $t('status.jv.reject') }}</span>
              </a>
            </div>
          </div>
          <!-- status message -->
          <div
            v-else
            class="dropdown nodro item">
            <template>
              <span
                v-if="journalEntry.status == 'pending'"
                class="text-warning">
                {{ $t('status.jv.pending') }}
              </span>
              <span
                v-else-if="journalEntry.status == 'approved'"
                class="text-success">
                {{ $t('status.jv.approved') }}
              </span>
              <span
                v-else-if="journalEntry.status == 'rejected'"
                class="text-danger">
                {{ $t('status.jv.rejected') }}
              </span>
            </template>
          </div>
        </div>
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <WrapperDoc>
        <template #form>
          <JournalEntryForm
            v-if="journalEntry"
            :journalEntry="journalEntry"
            :jvCode="journalEntry.jv_code"
            :isSubmitted="isSubmitted"
            :disabled="disabled || disabledForm"
            :form.sync="form"
            :showActionButtons="!disabledForm"
            @onSubmit="handleSubmit"
          />
        </template>
        <template #ref>
          <DocRef
            v-if="journalEntry"
            :refDoc="`jv`"
            :refId="journalEntry._id"
            :refCode="journalEntry.jv_code"
            :showLog="getAccountSetting.log_topic.is_active"
            :showAttachFile="getAccountSetting.attach_file.is_active"
            :logTopics="getAccountSetting.log_topic.options"
            :isSubmitted="isSubmitted"
          />
        </template>
      </WrapperDoc>

      <baseConfirmDeleteModal
        :show="modal.show"
        :loading="modal.loading"
        @onClose="handleCloseModal"
        @onCancel="handleCancleModal"
        @onSubmit="handleSumitModal"
      />
      <BaseConfirmDiscardModal
        :show="confirmDiscardModal.show"
        @onCancel="handleDiscardCancleModal"
        @onConfirm="handleDiscardConfirmModal"
      />
      <BaseConfirmCloneModal
        :show="modalConfirmClone.show"
        :loading="modalConfirmClone.loading"
        @onClose="handleCloseCloneModal"
        @onCancel="handleCancleCloneModal"
        @onConfirm="handleConfirmCloneModal({
          payload: {
            data: payloadClone
          },
          createApiFn: insertJournalEntries,
          redirectTo: 'AccountsJournalEntryAll',
          refCode: 'jv_code',
        })"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import sidebarModule from './../../sidebarModule'
import _ from 'lodash'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'
import confirmCloneMixin from '@/mixins/confirmClone'
import JournalEntryForm from '../../../combine/JournalEntryForm.vue'
import BaseConfirmCloneModal from '@/components/base/BaseConfirmCloneModal'
import WrapperDoc from '@/components/combine/WrapperDoc.vue'
import DocRef from '@/components/combine/DocRef.vue'

export default {
  components: {
    JournalEntryForm,
    BaseConfirmCloneModal,
    WrapperDoc,
    DocRef,
  },
  mixins: [discardFormMixin, userPermissionMixin, confirmCloneMixin],
  data () {
    return {
      loading: true,
      isSubmitted: false,
      disabled: false,
      form: null,
      modal: {
        show: false,
        loading: false,
      },
    }
  },
  computed: {
    ...mapGetters({
      sidebar: 'getSidebar',
      journalEntry: 'journalEntry',
      getAccountSetting: 'getAccountSetting',
    }),
    disabledForm () {
      return this.journalEntry && [
        'approved',
        'rejected',
      ].includes(this.journalEntry.status) || !this.hasRoleEdit
    },
    payloadClone() {
      if (!this.journalEntry) {
        return null
      }
      const dataSet = {
        'jv_type': this.journalEntry.jv_type,
        'description': this.journalEntry.description || null,
        'status': 'pending',
        'refs': [],
        'lines': this.journalEntry.lines.map((line) => {
          return {
            'account_type': line.account_type,
            'account_code': line.account_code,
            'label': line.label || null,
            'debit': Number(line.debit),
            'credit': Number(line.credit),
          }
        }),
      }
      return dataSet
    },
  },
  methods: {
    ...mapActions([
      'getSingleJournalEntries',
      'getAccountsListChartOfAccounts',
      'updateJournalEntries',
      'updateStatusJournalEntries',
      'deleteJournalEntries',
      'insertJournalEntries',
    ]),
    async handleSubmit(form) {
      this.isSubmitted = true
      this.disabled = true
      const payload = {
        'description': form.description || null,
        'refs': [],
        'lines': form.lines.map((line) => {
          return {
            'account_type': line.account_type,
            'account_code': line.account_code,
            'label': line.label || null,
            'debit': Number(line.debit),
            'credit': Number(line.credit),
          }
        }),
      }
      const response = await this.updateJournalEntries({
        jvId: this.journalEntry._id,
        data: payload,
      })
      if (response.success) {
        await this.getSingleJournalEntries({
          jvId: this.$route.query.jv_id,
        })
        this.isSubmitted = false
        this.disabled = false
        this.notify(this.$vs, {
          text: this.$t('message.hasbeenupdated', { msg: this.journalEntry.jv_code }),
          color: 'success',
          icon: 'cloud',
        })
        this.showFinish(this.$Progress)
      }
    },
    async updateStatus (status) {
      this.isSubmitted = true
      this.disabled = true
      const response = await this.updateStatusJournalEntries({
        jvId: this.journalEntry._id,
        data: {
          status: status,
        },
      })
      await this.getSingleJournalEntries({
        jvId: this.$route.query.jv_id,
      })
      this.showFinish(this.$Progress)
      this.isSubmitted = false
      this.disabled = false
    },
    onOpenModal () {
      this.modal.show = true
    },
    handleCloseModal () {
      this.modal.show = false
    },
    handleCancleModal () {
      this.modal.show = false
    },
    async handleSumitModal () {
      this.modal.loading = true
      const response = await this.deleteJournalEntries({
        jvId: this.journalEntry._id,
      })
      if (response.success) {
        this.notify(this.$vs, {
          text: this.$t('message.hasbeendeleted', { msg: this.journalEntry.jv_code }),
          color: 'danger',
          icon: 'delete',
        })
        this.modal.loading = false
        this.modal.show = false
        this.$router.push({ name: 'AccountsJournalEntryAll' })
      }
    },
  },
  async created () {
    if (!this.$route.query.jv_id) {
      return this.$router.push({ name: 'AccountsJournalEntryAll' })
    }

    await Promise.all([
      this.getSingleJournalEntries({
        jvId: this.$route.query.jv_id,
      }),
      this.getAccountsListChartOfAccounts(),
    ])

    this.loading = false
    this.showFinish(this.$Progress)
  },
  beforeMount () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.accounts.title'),
      current: {
        app_name: 'accounts',
        app_id: 12,
        module_id: 6,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 4, [{
      'name': this.$route.query.jv_code,
      'router': {
        'name': 'AccountsJournalEntryEdit',
        'query': {
          jv_id: this.$route.query.jv_id,
          jv_code: this.$route.query.jv_code,
        },
      },
      'activeClass': 'active',
    }], {
      sidebarAtIdx: 4,
      submenuAtIdx: 2,
    })
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/apps/accounts/journalentry/Edit.vue